var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _g4, _path9, _path10, _g5, _path11, _g6, _path12, _g7, _path13, _g8, _path14, _g9, _path15, _g10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCheckout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 43,
    viewBox: "0 0 106 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.627 1.37744V16.3349H35.0685V14.5892L27.5898 5.68557V16.3349H25.0312V1.37744H27.5898V1.72186L27.5996 1.71595L35.0685 10.6097V1.37744H37.627Z",
    fill: "#D8D8D8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_406_18693",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 1,
    width: 14,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0692 1.3771H37.6277V16.3345H35.0692V14.5888L27.5905 5.68523V16.3345H25.032V1.3771H27.5905V1.72152L35.0692 10.6153V1.3771ZM37.6277 1.2787H34.9708V10.3319L27.6889 1.67232V1.2787H24.9336V16.4329H27.6889V5.95486L34.9708 14.6144V16.4231H37.7261V1.26886L37.6277 1.2787Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_406_18693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.7261 1.27948H24.9336V16.4337H37.7261V1.27948Z",
    fill: "url(#paint0_linear_406_18693)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8866 1.37775H16.3281V16.3352H18.8866V1.37775Z",
    fill: "#D8D8D8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_406_18693",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 1,
    width: 3,
    height: 16
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3289 1.37703H18.8874V16.3344H16.3289V1.37703ZM18.8874 1.27863H16.2305V16.4328H18.9858V1.27863H18.8874Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_406_18693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9858 1.27863H16.2305V16.4328H18.9858V1.27863Z",
    fill: "url(#paint1_linear_406_18693)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5779 3.92041H4.10073L8.31439 8.13211V10.8717H3.04781V16.1383H0.308241V8.13211H4.85647L0.644784 3.92041H0.0976562V1.18085H9.5779V3.92041Z",
    fill: "#D8D8D8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_406_18693",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 10,
    height: 16
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.098404 1.1805H9.57865V3.91416H4.09361L8.30727 8.12585V10.8654H3.04856V16.132H0.308989V8.13176H4.85722L0.645532 3.91416H0.098404V1.1805ZM9.57865 1.08209H0V4.01847H0.606169L4.62105 8.03335H0.210585V16.2363H3.14696V10.9697H8.42338V8.09043L8.39583 8.0609L4.33962 4.01847H9.67705V1.08209H9.57865Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_406_18693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.67705 1.08209H0V16.2363H9.67705V1.08209Z",
    fill: "url(#paint2_linear_406_18693)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5465 13.5798V16.1383H63.3125V1.18085H65.871V13.5798H73.5465Z",
    fill: "#D8D8D8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_406_18693",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 1,
    width: 11,
    height: 16
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3133 1.1805H65.8718V13.5794H73.5473V16.1379H63.3133V1.1805ZM65.8718 1.08209H63.2109V16.2363H73.6418V13.481H65.9663V1.08209H65.8718Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_406_18693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.6457 1.08179H63.2148V16.236H73.6457V1.08179Z",
    fill: "url(#paint3_linear_406_18693)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2385 2.33939C54.6734 1.66567 53.9779 1.11335 53.1936 0.715722C52.3944 0.311073 51.5112 0.10022 50.6154 0.10022C49.7197 0.10022 48.8364 0.311073 48.0373 0.715722C46.8535 1.32534 45.8754 2.26991 45.2249 3.43167C44.5305 4.65895 44.1689 6.04634 44.1759 7.4564V16.3285H46.7344V10.9674H54.5083V16.3344H57.0668V7.4564C57.0812 5.58928 56.4358 3.77705 55.2444 2.33939M46.7344 8.40895V7.4564C46.7183 6.19296 47.1482 4.96432 47.9487 3.98667C48.2911 3.57808 48.7129 3.2433 49.1886 3.00263C49.6322 2.77598 50.1232 2.6578 50.6213 2.6578C51.1195 2.6578 51.6105 2.77598 52.0541 3.00263C52.7848 3.38835 53.3873 3.97853 53.788 4.70108C54.2612 5.54197 54.5074 6.49153 54.5024 7.4564V8.40304L46.7344 8.40895Z",
    fill: "#D8D8D8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_406_18693",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 14,
    height: 17
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8257 7.45698C46.8102 6.21848 47.2279 5.01349 48.0065 4.05023C48.3397 3.6491 48.7508 3.3197 49.2149 3.08193C49.6454 2.86326 50.1215 2.74929 50.6044 2.74929C51.0873 2.74929 51.5633 2.86326 51.9939 3.08193C52.7085 3.46177 53.2983 4.03994 53.6923 4.74693C54.1636 5.57226 54.4106 6.50658 54.4087 7.45698V8.30522H46.8316L46.8257 7.45698ZM49.1874 2.99534C48.7117 3.23601 48.2899 3.57079 47.9475 3.97938C47.1453 4.95911 46.7152 6.19085 46.7332 7.45698V8.40362H54.5071V7.45698C54.5121 6.49211 54.2659 5.54255 53.7927 4.70166C53.3891 3.97671 52.7823 3.38563 52.047 3.00124C51.6034 2.77459 51.1124 2.65641 50.6142 2.65641C50.1161 2.65641 49.6251 2.77459 49.1815 3.00124M44.1747 7.45698C44.1682 6.04373 44.5318 4.65341 45.2296 3.42438C45.8801 2.26262 46.8582 1.31804 48.0419 0.708428C48.8411 0.303779 49.7243 0.0929257 50.6201 0.0929257C51.5159 0.0929257 52.3991 0.303779 53.1983 0.708428C53.9811 1.10904 54.6747 1.66404 55.2372 2.33997C56.4287 3.77763 57.0741 5.58986 57.0597 7.45698V16.3291H54.5012V10.968H46.7332V16.335H44.1747V7.45698ZM47.9927 0.625769C46.7912 1.24356 45.7986 2.20197 45.139 3.38108C44.4338 4.62341 44.0654 6.02845 44.0704 7.45698V16.4275H46.8257V11.0664H54.4087V16.4334H57.164V7.45698C57.1805 5.56337 56.5266 3.72497 55.3179 2.26715C54.7404 1.5833 54.0291 1.02474 53.2278 0.625769C52.4152 0.214369 51.5172 0 50.6064 0C49.6955 0 48.7975 0.214369 47.9849 0.625769",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_406_18693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.158 0.00012207H44.0703V16.4336H57.158V0.00012207Z",
    fill: "url(#paint4_linear_406_18693)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_406_18693",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 23,
    width: 20,
    height: 20
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8536 38.3939C27.7164 37.9109 26.7431 37.1095 26.0509 36.0861C25.4604 35.2081 25.0976 34.1969 24.9953 33.1438C24.893 32.0906 25.0544 31.0286 25.465 30.0534C25.948 28.9162 26.7494 27.9429 27.7729 27.2507C28.6512 26.6618 29.6622 26.3005 30.7149 26.1994C31.7676 26.0984 32.8288 26.2608 33.8032 26.672C34.9403 27.155 35.9136 27.9564 36.6058 28.9799C37.1963 29.8578 37.5591 30.869 37.6614 31.9221C37.7637 32.9753 37.6023 34.0373 37.1917 35.0126C36.7087 36.1497 35.9073 37.123 34.8839 37.8152C34.0055 38.4042 32.9945 38.7654 31.9418 38.8665C30.8891 38.9675 29.8279 38.8051 28.8536 38.3939ZM24.622 25.8218C23.0702 27.3737 22.1045 29.4157 21.8894 31.5998C21.6744 33.7839 22.2233 35.975 23.4426 37.7998C24.662 39.6246 26.4763 40.9701 28.5765 41.6071C30.6767 42.2441 32.9328 42.1332 34.9604 41.2933C36.9879 40.4534 38.6616 38.9364 39.6961 37.0008C40.7306 35.0653 41.0619 32.8309 40.6337 30.6784C40.2055 28.5259 39.0441 26.5885 37.3476 25.1963C35.651 23.804 33.5242 23.0431 31.3296 23.0432C30.0837 23.0421 28.8498 23.2869 27.6988 23.7638C26.5477 24.2406 25.5021 24.94 24.622 25.8218Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_406_18693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.816 23.0505H21.8438V42.0228H40.816V23.0505Z",
    fill: "url(#paint5_linear_406_18693)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_406_18693",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 23,
    width: 16,
    height: 20
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M57.81 23.0502V33.4466C57.8264 34.9149 57.3073 36.339 56.3498 37.4523C55.9284 37.936 55.4139 38.3297 54.8369 38.6099C54.2855 38.8801 53.6797 39.0205 53.0657 39.0205C52.4517 39.0205 51.8459 38.8801 51.2946 38.6099C50.4112 38.1697 49.6764 37.48 49.1812 36.6262C48.6131 35.6633 48.316 34.5646 48.3214 33.4466V23.0502H45.1994V33.4466C45.1848 35.6763 45.9821 37.8351 47.4425 39.5201C48.1408 40.3149 48.9907 40.9624 49.9425 41.4245C50.9155 41.8966 51.983 42.1419 53.0645 42.1419C54.146 42.1419 55.2135 41.8966 56.1865 41.4245C57.6261 40.7217 58.8271 39.6109 59.64 38.2305C60.4989 36.7831 60.9488 35.1296 60.9416 33.4466V23.0502H57.81Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_406_18693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.9294 23.0505H45.1992V42.1428H60.9294V23.0505Z",
    fill: "url(#paint6_linear_406_18693)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_406_18693",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 22,
    width: 19,
    height: 21
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7861 26.0523H97.6521C98.1773 26.0578 98.6914 26.2037 99.1411 26.475C100.002 27.0253 100.686 27.8136 101.108 28.7445C101.674 29.9346 101.961 31.238 101.949 32.5557C101.952 33.4606 101.819 34.3608 101.555 35.2263C101.245 36.3134 100.659 37.302 99.8544 38.0961C99.5362 38.3963 99.1691 38.64 98.7689 38.8166C98.4156 38.9732 98.0337 39.0549 97.6473 39.0567H90.7861V26.0523ZM89.105 22.9303V23.0504H87.6641V42.2628H90.7861V42.1812H97.6521C98.7303 42.1759 99.7875 41.8824 100.714 41.331C102.107 40.4742 103.219 39.2275 103.911 37.7455C104.687 36.1265 105.084 34.3514 105.071 32.5557C105.075 31.335 104.895 30.1206 104.537 28.9534C104.067 27.345 103.187 25.8867 101.982 24.7219C101.402 24.1749 100.732 23.7321 100.001 23.413C99.2575 23.0935 98.4564 22.93 97.6473 22.9327L89.105 22.9303Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_406_18693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.075 22.9303H87.6641V42.2628H105.075V22.9303Z",
    fill: "url(#paint7_linear_406_18693)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_406_18693",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 23,
    width: 16,
    height: 20
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6776 23.0502V34.9114L69.5613 23.4849L69.5517 23.4945V23.0502H66.4297V42.2626H69.5517V28.5833L78.6776 40.0219V42.2626H81.7996V23.0502H78.6776Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_406_18693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.7996 23.0502H66.4297V42.2626H81.7996V23.0502Z",
    fill: "url(#paint8_linear_406_18693)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_406_18693",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 23,
    width: 16,
    height: 20
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27476 26.6695H9.16433C9.87279 26.6582 10.5593 26.9156 11.0856 27.39C11.3131 27.6011 11.4981 27.8538 11.6307 28.1345C11.7558 28.4051 11.8206 28.6997 11.8206 28.9978C11.8206 29.296 11.7558 29.5905 11.6307 29.8612C11.4256 30.2917 11.1003 30.6537 10.6941 30.9034C10.2381 31.1873 9.71108 31.3364 9.17393 31.3333H8.95059L4.27476 26.6695ZM0.0096046 23.5475V26.6695H0.0648411L0 26.7343L4.60618 31.3405H0.0096046V34.4626H0.0264154V42.0563H3.47024V34.4626H3.76083L11.393 42.0923H15.7374L8.10764 34.4626H9.16433C10.6571 34.4688 12.0971 33.9113 13.1965 32.9015C13.7273 32.413 14.1566 31.8246 14.4598 31.17C14.7704 30.4918 14.9313 29.7546 14.9313 29.0086C14.9313 28.2626 14.7704 27.5254 14.4598 26.8472C14.0009 25.8625 13.2648 25.0329 12.3416 24.4601C11.3886 23.8658 10.2874 23.552 9.16433 23.5547L0.0096046 23.5475Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_406_18693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7368 23.5475H-0.0078125V42.0923H15.7368V23.5475Z",
    fill: "url(#paint9_linear_406_18693)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_406_18693",
    x1: 24.906,
    y1: 8.80936,
    x2: 37.6986,
    y2: 8.80936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#392C81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D2A90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_406_18693",
    x1: 16.2206,
    y1: 8.84589,
    x2: 18.9759,
    y2: 8.84589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#392C81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D2A90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_406_18693",
    x1: -0.0312334,
    y1: 8.60829,
    x2: 9.64582,
    y2: 8.60829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#392C81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D2A90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_406_18693",
    x1: 63.203,
    y1: 8.61953,
    x2: 73.6339,
    y2: 8.61953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#392C81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D2A90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_406_18693",
    x1: 44.089,
    y1: 8.16864,
    x2: 57.1767,
    y2: 8.16864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#392C81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D2A90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_406_18693",
    x1: 21.8918,
    y1: 32.467,
    x2: 40.8641,
    y2: 32.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A2E8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#732B90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B2A90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_406_18693",
    x1: 45.198,
    y1: 32.4778,
    x2: 60.9282,
    y2: 32.4778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A2E8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#732B90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B2A90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_406_18693",
    x1: 87.604,
    y1: 32.5329,
    x2: 105.015,
    y2: 32.5329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A2E8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#732B90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B2A90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_406_18693",
    x1: 66.36,
    y1: 32.5987,
    x2: 81.73,
    y2: 32.5987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A2E8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#732B90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B2A90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_406_18693",
    x1: 0.0384895,
    y1: 32.7595,
    x2: 15.7831,
    y2: 32.7595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A2E8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#562D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#6A2B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#772A90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B2A90"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCheckout);
export default __webpack_public_path__ + "static/media/logo-checkout.518a9cfa52cb59b01206243584f37c12.svg";
export { ForwardRef as ReactComponent };